import React from 'react'
import { Formik, Form } from 'formik'
import { Button } from 'react-bootstrap'
import {
  DISPLAY_MODE_STANDARD,
  GATED_MODE_EMAIL_GATE,
  GATED_MODE_PASSWORD,
  GATED_MODE_STANDARD,
  LABEL_MAP
} from '../interface'
import DomainForm from './components/DomainForm'
import FileSelectionForm from './components/FileSelectionForm'
import ToggleButtonsForm from './components/ToggleButtonsForm'
import { getDomainSuffix } from 'utils/general'
import { PRO_MAX_FILE_SIZES } from 'constants/plans'
import { getFileType } from 'utils/file'

const CreateUpdateSiteForm = ({ formValues, onSubmit, validate }) => {
  const { action, userProfile, site, customDomains, tlds, disableProFeatures, draggedFile, currentFormValues } =
    formValues
  const { productId } = userProfile

  const {
    subdomain = '',
    passwordProtected = false,
    password = '',
    fileUploadLimit = PRO_MAX_FILE_SIZES[productId],
    disableIndexing = false,
    disableExportPdf = false,
    siteConfiguration = false,
    displayMode = DISPLAY_MODE_STANDARD,
    enableEmailGate = false,
    filename = ''
  } = site || {}

  const domainFormValues = {
    subdomain: subdomain.split('.')[0] || '',
    domainSuffix: getDomainSuffix(subdomain).tld || tlds[0],
    customDomains: customDomains,
    tlds
  }
  /**
   *
   */
  const uploadFormValues = {
    selectedFile: draggedFile,
    addedFiles: [],
    fileUploadLimit,
    progress: 0,
    indexFile: null,
    fileType: getFileType(filename || draggedFile?.name)
  }

  const toggleFormValues = {
    displayMode: displayMode,
    gatedMode: enableEmailGate ? GATED_MODE_EMAIL_GATE : passwordProtected ? GATED_MODE_PASSWORD : GATED_MODE_STANDARD,
    passwordProtected,
    password: enableEmailGate ? '' : password,
    disableIndexing: disableIndexing === 'true',
    disableExportPdf,
    siteConfiguration,
    errorPath: siteConfiguration ? JSON.parse(siteConfiguration).errorPath : '/'
  }

  const initialValues = currentFormValues || {
    domainValues: domainFormValues,
    uploadValues: uploadFormValues,
    toggleValues: toggleFormValues
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => onSubmit(values, initialValues)}
      validate={(values) => validate(action, values)}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({ values: { domainValues, uploadValues, toggleValues }, setFieldValue }) => {
        return (
          <Form>
            <DomainForm
              name={'domainValues'}
              initialValues={domainValues}
              userProfile={userProfile}
              action={action}
              disableProFeatures={disableProFeatures}
              setFieldValue={setFieldValue}
            />
            <FileSelectionForm
              name={'uploadValues'}
              initialValues={uploadValues}
              draggedFile={draggedFile}
              userProfile={userProfile}
              setFieldValue={setFieldValue}
            />
            <ToggleButtonsForm
              name={'toggleValues'}
              initialValues={toggleValues}
              userProfile={userProfile}
              uploadValues={uploadValues}
              setFieldValue={setFieldValue}
            />
            <Button className="action-btn" type="submit">
              {LABEL_MAP[action]}
            </Button>
          </Form>
        )
      }}
    </Formik>
  )
}

export default CreateUpdateSiteForm
